import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Dashboard from './Dashboard';
import Navbar from './Navbar';
import Login from './Login';
import pb from './pocketbase';
import Sellers from './Sellers';
import CustomersPage from './Customers';
import Products from './Products';
import Orders from './Orders';
import Categories from './Categories';
import Settings from './Settings';
import AdminManagement from './AdminManagement';
import Banners from './Banners';
import QnaManagement from './Qna';
import PaymentsManagement from './Payment';
import SitemapGenerator from './SitemapGenerator';
import SupportMessages from './SupportMessages';
import SupportConversation from './SupportConversation';
import SellerChat from './SellerChat';
// Protected Route component
const ProtectedRoute = ({ children }) => {
  if (!pb.authStore.isValid) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    {/* Navbar will only show when authenticated due to its internal check */}
    <Navbar />
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      
      {/* Protected routes */}
      <Route path="/" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/sellers" element={
        <ProtectedRoute>
          <Sellers />
        </ProtectedRoute>
      } />
      <Route path="/customers" element={
        <ProtectedRoute>
          <CustomersPage />
        </ProtectedRoute>
      } />
      <Route path="/products" element={
        <ProtectedRoute>
           <Products />
        </ProtectedRoute>
      } />
      <Route path='/orders' element={
        <ProtectedRoute>
          <Orders />
        </ProtectedRoute>
      } />
      <Route path="/categories" element={
        <ProtectedRoute>
          <Categories />
        </ProtectedRoute>
      } />
      <Route path='/settings' element={
        <ProtectedRoute>
          <Settings />
        </ProtectedRoute>
      } />
      <Route path='/admin-management' element={
        <ProtectedRoute>
          <AdminManagement />
        </ProtectedRoute>
      } />
      <Route path='/banners' element={
        <ProtectedRoute>
          <Banners />
        </ProtectedRoute>
      } />
      <Route path='/qna' element={
        <ProtectedRoute>
          <QnaManagement />
        </ProtectedRoute>
      } />
      <Route path='/payments' element={ 
        <ProtectedRoute>
          <PaymentsManagement />
        </ProtectedRoute>
      } />
      <Route path='/sitemap-generator' element={
        <ProtectedRoute>
          <SitemapGenerator />
        </ProtectedRoute>
      } />
      {/* Support Message Routes */}
      <Route path='/support-messages' element={
        <ProtectedRoute>
          <SupportMessages />
        </ProtectedRoute>
      } />
      <Route path='/support-conversation/:id' element={
        <ProtectedRoute>
          <SupportConversation />
        </ProtectedRoute>
      } />
      <Route             path="/seller-chat" 
        element={
        <ProtectedRoute>
          <SellerChat />
        </ProtectedRoute>
      } />
      {/* 404 Not Found */}
      
      {/* Fallback route */}
      
      {/* Redirect to dashboard if authenticated, otherwise to login */}
      <Route path="*" element={
        pb.authStore.isValid ? 
          <Navigate to="/dashboard" replace /> : 
          <Navigate to="/login" replace />
      } />
    </Routes>
  </BrowserRouter>
);

reportWebVitals();